module.exports = __webpack_public_path__ + "static/media/pragati-meeting-om.1ee19ab0.svg";